<template>

  <transition name="fade">

    <div id="cookie" class="hit-html-html hit-bg-info" :key="getCookie()" :class="{fullscreen: this.$route.name == 'cookie'}">

      <div class="cookie-inset hit-text-white">

        <h3 class="hit-html-h3">{{ $t("message.cookie") }}</h3>
        <div class="hit-form-group" v-html="cookie"></div>

        <div class="hit-form-group">
          <a href="#" @click.prevent="setCookie('essential')" class="hit-btn hit-btn-xs hit-btn-primary">{{ $t("message.allowEssentialCookies") }}</a>&nbsp;
          <a href="#" @click.prevent="setCookie('all')" class="hit-btn hit-btn-xs hit-btn-primary">{{ $t("message.allowAllCookies") }}</a>
        </div>

        <div class="hit-form-group">
          <router-link class="hit-text-danger" :to="{ name: 'privacy', params: {lang: $route.params.lang} }">{{ $t("message.privacy") }}</router-link>
        </div>

      </div>
    </div>
  </transition>

</template>

<script>

import de from 'raw-loader!@shared/language/cookie/de_DE.txt'

var cookie = {
  'de': ''
}

cookie.de = de

export default {

  name: 'cookie',
  data () {
    var lang = this.$route.params.lang

    if (typeof cookie[lang] !== 'string') { lang = 'de' }

    return {
      cookie: cookie[lang]
    }
  },

  methods: {
    getCookie () {
      if (typeof this.$store.getters.cookie === 'string' && this.$store.getters.cookie.length) { return this.$store.getters.cookie }

      return ''
    },
    setCookie (type) {
      localStorage.setItem('hit_cookie_settings', type)
      this.$store.commit('set_cookie', type)

      if (this.$route.name == 'cookie') { this.$router.push({name: 'privacy', params: this.$route.params}) }
    }
  }

}
</script>

<style scoped>
#cookie{

  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  min-height: 20vh;

  z-index: 3;
  display: flex;
  flex-wrap:wrap;
  align-items: center;
  vertical-align: center;
  text-align: center;

}

#cookie.fullscreen{
  min-height: 100vh;
}
#cookie .cookie-inset{
  font-size: 10pt;
  width: 50%;
  margin: 0 auto;
  padding: 10px;
  box-sizing: border-box;
}

@media(max-width: 768px){
  #cookie .cookie-inset{
    width: 90%;
    font-size: 8pt;
  }
}
</style>
